
import React from "react";
import { events } from "../../services/events";
import PostList from "./PostList";

const EventPage = () => {
    return <PostList fetchPostsFn={events} sectionTitle="Latest Events" />;
};

export default EventPage;
